import React, { useEffect, useState } from "react";
import { CalendarClock, Flame } from "lucide-react";
import client from "../../lib/api";
import { Spinner } from "../ui-kit";

const left = (iso) => {
  const m = Math.round((new Date(iso).getTime() - Date.now()) / 60000);
  if (m < 60) return `${m} min`;
  if (m < 1440) return `${Math.floor(m / 60)}h ${m % 60}m`;
  return `${Math.floor(m / 1440)}d`;
};
const when = (iso) => new Date(iso).toLocaleString(undefined, { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
const val = (v) => (v === null || v === undefined || v === "None" || v === "" ? "—" : v);

function Row({ e, past }) {
  const high = e.impact === "High";
  return (
    <div className="flex items-center gap-3 px-4 py-3 border-b border-[color:var(--border-subtle)] last:border-0" data-testid={`event-${e.id}`}>
      <span className={`w-1.5 h-8 shrink-0 ${high ? "bg-bear" : "bg-gold"}`} />
      <div className="flex-1 min-w-0">
        <div className="text-sm text-white truncate">{e.title} <span className="text-xs text-slate-500">{e.currency}</span></div>
        <div className="text-[11px] text-slate-500">{when(e.time)} · affects {e.affects || "Gold/BTC"}</div>
      </div>
      {past ? (
        <div className="text-right shrink-0 text-[11px] font-mono"><div className="text-white">A: {val(e.actual)}</div><div className="text-slate-500">F: {val(e.forecast)}</div></div>
      ) : <div className="text-right shrink-0"><div className={`text-xs font-mono ${high ? "text-bear" : "text-gold"}`}>{left(e.time)}</div><div className="text-[10px] text-slate-500">{e.impact}</div></div>}
    </div>
  );
}

export function EventsFeed() {
  const [d, setD] = useState(null);
  useEffect(() => {
    client.get("/hub/events").then(({ data }) => setD(data)).catch(() => setD({ upcoming: [], recent: [] }));
  }, []);
  if (!d) return <Spinner label="Loading events" />;
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2" data-testid="events-feed">
      <div className="surface min-w-0">
        <div className="px-4 py-3 border-b border-[color:var(--border-subtle)] text-sm text-white flex items-center gap-2"><CalendarClock size={15} className="text-gold" />Upcoming (7 days)</div>
        {d.upcoming.length ? d.upcoming.map((e) => <Row key={e.id} e={e} />) : <div className="p-6 text-sm text-slate-500 text-center">Koi badi event nahi.</div>}
      </div>
      <div className="surface min-w-0">
        <div className="px-4 py-3 border-b border-[color:var(--border-subtle)] text-sm text-white flex items-center gap-2"><Flame size={15} className="text-bear" />Recently released · High impact</div>
        {d.recent.length ? d.recent.map((e) => <Row key={e.id} e={e} past />) : <div className="p-6 text-sm text-slate-500 text-center">Pichhle 3 din me koi high-impact release nahi.</div>}
        <p className="px-4 py-3 text-[11px] text-slate-500">Phone alerts ON hone par badi news se 15 min pehle aur result aate hi alert aata hai.</p>
      </div>
    </div>
  );
}
